// Skip age-gate modal for known crawlers and for users with prior consent cookie.
// Age-gates are explicitly exempt from cloaking rules per Google Search Central docs.
const CRAWLER_REGEX =
  /(Googlebot|Google-InspectionTool|GoogleOther|Mediapartners-Google|AdsBot-Google|Bingbot|DuckDuckBot|Baiduspider|Slurp|facebookexternalhit|Twitterbot|Applebot|LinkedInBot|SemrushBot|AhrefsBot|PetalBot)/i;

export default function ({ app, req, store }) {
  if (!process.server) return;

  const ua = (req && req.headers && req.headers["user-agent"]) || "";
  const isCrawler = CRAWLER_REGEX.test(ua);
  const consentRaw = app.$cookies.get("is-adult");
  const hasConsent = consentRaw === true || consentRaw === "true";

  store.commit("global/setIsAdult", hasConsent || isCrawler);
}
